import {Component, OnInit} from '@angular/core';
import {CountryChartData} from '../../../../models/country-chart-data.interface';
import {Master} from '../../../../../admin/models/master.interface';
import {KfChartsService} from '../../../../services/kf-charts.service';
import {ChartsSearchInterface} from '../../../../models/charts-search.interface';
import {ActivatedRoute, Router} from '@angular/router';
import {buildQueryParams, getFiltersFromQueryParams} from '../../../../utils/filters-utils';
import {CountryChartInfo} from '../../../../models/country-chart-info.interface';

@Component({
  selector: 'app-trend-by-country',
  templateUrl: './trend-by-country.component.html',
  styleUrls: ['./trend-by-country.component.scss']
})
export class TrendByCountryComponent implements OnInit {

  text = 'Trend in return rates';
  subtitle = '';
  countries!: CountryChartInfo[];
  data!: [CountryChartData[]];
  displayUnits = 'ABSOLUTE';
  years!: number[];
  categories!: Master[];

  constructor(private readonly kfChartsService: KfChartsService,
              private readonly router: Router,
              private readonly activatedRoute: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.kfChartsService.getCollectionStreams().subscribe(data => this.categories = data);
    this.activatedRoute.queryParams.subscribe((params) => {
      const search = getFiltersFromQueryParams(params);

      this.kfChartsService.getYears('collected', 'COUNTRY_SCHEMA')
        .subscribe(availableYears => {
          this.years = availableYears;
          if (availableYears.length > 0) {

            if (!search.startYear) {
              search.startYear = availableYears[2];
            }
            this.subtitle = search.startYear + ' - ' + this.years[0] + ' (%)';
          } else {
            this.subtitle = 'No data';
          }
          if (!search.categoryType) {
            search.categoryType = 'NEW';
          }
          if (!search.displayUnits) {
            search.displayUnits = 'ABSOLUTE';
          }
          this.kfChartsService.getCountriesReturnTrendByCountry(search, 'collected').subscribe(
            response => this.countries = response
          );
          this.kfChartsService.getReturnTrendByCountry(search, 'collected')
            .subscribe(response => {
            this.data = response;
          });
        });
    });
  }

  searchData(event: ChartsSearchInterface): void {
    this.router.navigate([this.router.url.split('?')[0]], {queryParams: buildQueryParams(event)});

    if (event.displayUnits && event.displayUnits !== '') {
      this.displayUnits = event.displayUnits;
    }

  }

  loadCategories(event: string): void {
    if (event === 'OLD') {
      this.kfChartsService.getOldPomCategories().subscribe(data => this.categories = data);
    } else {
      this.kfChartsService.getPomCategories().subscribe(data => this.categories = data);
    }
  }

}
